import React from "react";
import {
    resolveVehicleDelayBadgeStyle,
    VEHICLE_ISLAND_DELAY_BADGE_LINE_CLASS,
    VEHICLE_ISLAND_DELAY_BADGE_SHELL_CLASS,
    vehicleIslandTrailingControlHeightStyle,
    type VehicleDelayBadgePresentation,
} from "./vehicleInfoChrome.tools";

interface VehicleIslandDelayBadgeProps {

    /** Resolved delay badge content and pill colors. */
    "presentation": VehicleDelayBadgePresentation;
}

/**
 * Two-line delay/advance pill for the vehicle island trailing cluster.
 *
 * @param props Badge props.
 * @returns Delay badge or null when presentation is incomplete.
 */
const VehicleIslandDelayBadge: React.FC<VehicleIslandDelayBadgeProps> = ( { presentation } ) => {
    if ( presentation.statusLine === null || presentation.valueLine === null ) {
        return null;
    }

    const badgeStyle = resolveVehicleDelayBadgeStyle( presentation );

    if ( badgeStyle === undefined ) {
        return null;
    }

    return (
        <div
            aria-hidden={true}
            className={VEHICLE_ISLAND_DELAY_BADGE_SHELL_CLASS}
            style={{
                ...badgeStyle,
                ...vehicleIslandTrailingControlHeightStyle,
            }}
        >
            <span className={VEHICLE_ISLAND_DELAY_BADGE_LINE_CLASS}>
                {presentation.statusLine}
            </span>
            <span className={VEHICLE_ISLAND_DELAY_BADGE_LINE_CLASS}>
                {presentation.valueLine}
            </span>
        </div>
    );
};

export default VehicleIslandDelayBadge;
